module.exports = __webpack_public_path__ + "static/media/perotto.939ed86d.gif";